/**
 * AUTO-GENERATED — DO NOT EDIT
 *
 * Generated by tools/gen-sqlite-from-db-schema.ts
 * To regenerate, run: pnpm powersync:schema:generate
 */

import { appConfig } from './app_config.js';
import { appointmentCalendarSettings } from './appointment_calendar_settings.js';
import { appointmentCategories } from './appointment_categories.js';
import { appointmentProviderTypes } from './appointment_provider_types.js';
import { appointmentProviders } from './appointment_providers.js';
import { appointmentServices } from './appointment_services.js';
import { appointmentStatuses } from './appointment_statuses.js';
import { appointments } from './appointments.js';
import { bookingFrontdeskPatientFieldSettings } from './booking_frontdesk_patient_field_settings.js';
import { bookingFrontdeskProviderSettings } from './booking_frontdesk_provider_settings.js';
import { bookingFrontdeskServiceSettings } from './booking_frontdesk_service_settings.js';
import { bookingFrontdeskSettings } from './booking_frontdesk_settings.js';
import { bookingOnlinePatientFieldSettings } from './booking_online_patient_field_settings.js';
import { bookingOnlineProviderSettings } from './booking_online_provider_settings.js';
import { bookingOnlineServiceSettings } from './booking_online_service_settings.js';
import { bookingOnlineSettings } from './booking_online_settings.js';
import { chartingTemplates } from './charting_templates.js';
import { encounterTabSettings } from './encounter_tab_settings.js';
import { encounterVisualCharts } from './encounter_visual_charts.js';
import { formDefinitions } from './form_definitions.js';
import { formInstanceSignatures } from './form_instance_signatures.js';
import { formInstanceValues } from './form_instance_values.js';
import { formInstances } from './form_instances.js';
import { formTemplateMappings } from './form_template_mappings.js';
import { formTemplatePages } from './form_template_pages.js';
import { intakeFormDefinitions } from './intake_form_definitions.js';
import { intakeFormResponses } from './intake_form_responses.js';
import { invoiceItems } from './invoice_items.js';
import { invoicePayments } from './invoice_payments.js';
import { invoices } from './invoices.js';
import { odontogramCharts } from './odontogram_charts.js';
import { patientAllergies } from './patient_allergies.js';
import { patientContacts } from './patient_contacts.js';
import { patientEmergencyContacts } from './patient_emergency_contacts.js';
import { patientEncounters } from './patient_encounters.js';
import { patientFieldDefinitions } from './patient_field_definitions.js';
import { patientFiles } from './patient_files.js';
import { patientForms } from './patient_forms.js';
import { patientIdentifiers } from './patient_identifiers.js';
import { patientIntakeForms } from './patient_intake_forms.js';
import { patientNotes } from './patient_notes.js';
import { patientTreatmentRecords } from './patient_treatment_records.js';
import { patientVisits } from './patient_visits.js';
import { patientVitalEntries } from './patient_vital_entries.js';
import { patients } from './patients.js';
import { queueEntries } from './queue_entries.js';
import { userPatientFavorites } from './user_patient_favorites.js';
import { userProviderLinks } from './user_provider_links.js';
import { users } from './users.js';
import { vitalDefinitions } from './vital_definitions.js';

// Re-export individual table definitions
export { appConfig } from './app_config.js';
export { appointmentCalendarSettings } from './appointment_calendar_settings.js';
export { appointmentCategories } from './appointment_categories.js';
export { appointmentProviderTypes } from './appointment_provider_types.js';
export { appointmentProviders } from './appointment_providers.js';
export { appointmentServices } from './appointment_services.js';
export { appointmentStatuses } from './appointment_statuses.js';
export { appointments } from './appointments.js';
export { bookingFrontdeskPatientFieldSettings } from './booking_frontdesk_patient_field_settings.js';
export { bookingFrontdeskProviderSettings } from './booking_frontdesk_provider_settings.js';
export { bookingFrontdeskServiceSettings } from './booking_frontdesk_service_settings.js';
export { bookingFrontdeskSettings } from './booking_frontdesk_settings.js';
export { bookingOnlinePatientFieldSettings } from './booking_online_patient_field_settings.js';
export { bookingOnlineProviderSettings } from './booking_online_provider_settings.js';
export { bookingOnlineServiceSettings } from './booking_online_service_settings.js';
export { bookingOnlineSettings } from './booking_online_settings.js';
export { chartingTemplates } from './charting_templates.js';
export { encounterTabSettings } from './encounter_tab_settings.js';
export { encounterVisualCharts } from './encounter_visual_charts.js';
export { formDefinitions } from './form_definitions.js';
export { formInstanceSignatures } from './form_instance_signatures.js';
export { formInstanceValues } from './form_instance_values.js';
export { formInstances } from './form_instances.js';
export { formTemplateMappings } from './form_template_mappings.js';
export { formTemplatePages } from './form_template_pages.js';
export { intakeFormDefinitions } from './intake_form_definitions.js';
export { intakeFormResponses } from './intake_form_responses.js';
export { invoiceItems } from './invoice_items.js';
export { invoicePayments } from './invoice_payments.js';
export { invoices } from './invoices.js';
export { odontogramCharts } from './odontogram_charts.js';
export { patientAllergies } from './patient_allergies.js';
export { patientContacts } from './patient_contacts.js';
export { patientEmergencyContacts } from './patient_emergency_contacts.js';
export { patientEncounters } from './patient_encounters.js';
export { patientFieldDefinitions } from './patient_field_definitions.js';
export { patientFiles } from './patient_files.js';
export { patientForms } from './patient_forms.js';
export { patientIdentifiers } from './patient_identifiers.js';
export { patientIntakeForms } from './patient_intake_forms.js';
export { patientNotes } from './patient_notes.js';
export { patientTreatmentRecords } from './patient_treatment_records.js';
export { patientVisits } from './patient_visits.js';
export { patientVitalEntries } from './patient_vital_entries.js';
export { patients } from './patients.js';
export { queueEntries } from './queue_entries.js';
export { userPatientFavorites } from './user_patient_favorites.js';
export { userProviderLinks } from './user_provider_links.js';
export { users } from './users.js';
export { vitalDefinitions } from './vital_definitions.js';

/**
 * Combined Drizzle schema object.
 * Keys MUST match the PowerSync table names used in sync rules.
 */
export const drizzleSchema = {
  app_config: appConfig,
  appointment_calendar_settings: appointmentCalendarSettings,
  appointment_categories: appointmentCategories,
  appointment_provider_types: appointmentProviderTypes,
  appointment_providers: appointmentProviders,
  appointment_services: appointmentServices,
  appointment_statuses: appointmentStatuses,
  appointments: appointments,
  booking_frontdesk_patient_field_settings: bookingFrontdeskPatientFieldSettings,
  booking_frontdesk_provider_settings: bookingFrontdeskProviderSettings,
  booking_frontdesk_service_settings: bookingFrontdeskServiceSettings,
  booking_frontdesk_settings: bookingFrontdeskSettings,
  booking_online_patient_field_settings: bookingOnlinePatientFieldSettings,
  booking_online_provider_settings: bookingOnlineProviderSettings,
  booking_online_service_settings: bookingOnlineServiceSettings,
  booking_online_settings: bookingOnlineSettings,
  charting_templates: chartingTemplates,
  encounter_tab_settings: encounterTabSettings,
  encounter_visual_charts: encounterVisualCharts,
  form_definitions: formDefinitions,
  form_instance_signatures: formInstanceSignatures,
  form_instance_values: formInstanceValues,
  form_instances: formInstances,
  form_template_mappings: formTemplateMappings,
  form_template_pages: formTemplatePages,
  intake_form_definitions: intakeFormDefinitions,
  intake_form_responses: intakeFormResponses,
  invoice_items: invoiceItems,
  invoice_payments: invoicePayments,
  invoices: invoices,
  odontogram_charts: odontogramCharts,
  patient_allergies: patientAllergies,
  patient_contacts: patientContacts,
  patient_emergency_contacts: patientEmergencyContacts,
  patient_encounters: patientEncounters,
  patient_field_definitions: patientFieldDefinitions,
  patient_files: patientFiles,
  patient_forms: patientForms,
  patient_identifiers: patientIdentifiers,
  patient_intake_forms: patientIntakeForms,
  patient_notes: patientNotes,
  patient_treatment_records: patientTreatmentRecords,
  patient_visits: patientVisits,
  patient_vital_entries: patientVitalEntries,
  patients: patients,
  queue_entries: queueEntries,
  user_patient_favorites: userPatientFavorites,
  user_provider_links: userProviderLinks,
  users: users,
  vital_definitions: vitalDefinitions,
};
